import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78bbabfd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cart-service-table" }
const _hoisted_2 = { class: "d-flex justify-content-between flex-wrap" }
const _hoisted_3 = { class: "text-primary" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-spin pi-spinner" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "ml-auto" }
const _hoisted_9 = {
  key: 0,
  class: "lead d-flex justify-content-end pr-1"
}
const _hoisted_10 = { class: "mr-3 text-bold" }
const _hoisted_11 = { class: "text-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ColumnProductName = _resolveComponent("ColumnProductName")!
  const _component_Column = _resolveComponent("Column")!
  const _component_PriceSummary = _resolveComponent("PriceSummary")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.microServiceProduct?.name), 1),
      _createElementVNode("div", null, [
        (_ctx.canChangeConfiguration && _ctx.isEditable)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "p-button-secondary p-button-text flex-shrink-0 hidden-print",
              icon: "pi pi-cog",
              label: _ctx.$t('cart.button.editConfiguration'),
              title: _ctx.$t('cart.button.editConfiguration'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => {
						_ctx.onChangeConfigurationClick();
						$event.target.disabled = true;
					})
            }, null, 8, ["label", "title"]))
          : _createCommentVNode("", true),
        (_ctx.isEditable)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              class: "p-button-text p-button-danger hidden-print flex-shrink-0",
              icon: "pi pi-times",
              label: _ctx.$t('cart.button.removeItem'),
              title: _ctx.$t('cart.button.removeItem'),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onRemoveFromCartClick()))
            }, null, 8, ["label", "title"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_DataTable, {
      breakpoint: "1150px",
      "data-key": "id",
      "responsive-layout": "stack",
      value: _ctx.editingCartLines
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "productName",
          header: _ctx.$t('cart.table.colName'),
          style: { width: '25%' }
        }, {
          body: _withCtx((item) => [
            _createVNode(_component_ColumnProductName, {
              item: _ctx.productNameColumnModel(item.data)
            }, null, 8, ["item"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column),
        _createVNode(_component_Column, {
          header: _ctx.$t('cart.table.colPrice'),
          style: {"width":"35%"}
        }, {
          body: _withCtx((item) => [
            (!_ctx.isSpinnerVisible(item.data.name))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_PriceSummary, {
                    vm: _ctx.modularPriceSummary(item.data)
                  }, null, 8, ["vm"])
                ]))
              : (_ctx.isSpinnerVisible(item.data.name))
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 1
    }, 8, ["value"]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.totalPriceSummary?.totalPrice)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("common.priceSummary.totalPrice")), 1),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formatCurrency(_ctx.totalPriceSummary?.totalPrice)), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}